var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLuggage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 4.99768V3.00001C6 1.89544 6.89543 1.00001 8 1.00001H20C21.1046 1.00001 22 1.89544 22 3V4.99768",
    stroke: "#222222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6.99646C0.895431 6.99646 0 7.89189 0 8.99646V23.9965C0 25.101 0.895431 25.9965 2 25.9965H26C27.1046 25.9965 28 25.101 28 23.9965V8.99646C28 7.89189 27.1046 6.99646 26 6.99646H2ZM7 12.1116C6.44772 12.1116 6 12.5594 6 13.1116C6 13.6639 6.44772 14.1116 7 14.1116H21C21.5523 14.1116 22 13.6639 22 13.1116C22 12.5594 21.5523 12.1116 21 12.1116H7Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99976 28H10.3998V30C10.3998 30.5523 9.95204 31 9.39976 31H5.99976C5.44747 31 4.99976 30.5523 4.99976 30V28Z",
    fill: "#222222"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5998 28H22.9998V30C22.9998 30.5523 22.552 31 21.9998 31H18.5998C18.0475 31 17.5998 30.5523 17.5998 30V28Z",
    fill: "#222222"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLuggage);
export default __webpack_public_path__ + "static/media/luggage.676f8eedb34f75d202d71c1c4ac4cb34.svg";
export { ForwardRef as ReactComponent };